import React from 'react';
import { classnames } from 'helpers/utils';
import styles from './payment-method.module.scss';

type PaymentMethodProps = {
  paymentMethod: PaymentMethodType;
};

const PaymentMethod: React.FC<PaymentMethodProps> = ({ paymentMethod }) => {
  const { lastFourDigits, expirationMonth, expirationYear, brand } =
    paymentMethod;

  return (
    <div className={styles.paymentMethodInfo}>
      <div className={styles.numberAndDate}>
        <span className="text__body__semi__bold__medium__gray800">
          {`**** ${lastFourDigits}`}
        </span>
        <span className="text__body__regular__medium__gray700">
          {`${expirationMonth}/${expirationYear}`}
        </span>
      </div>
      <div
        className={classnames(
          'text__body__semi__bold__tiny__gray800',
          styles.brand,
        )}
      >
        {brand}
      </div>
    </div>
  );
};

export { PaymentMethod };
